import { Button } from '@sentinel/ui';

export interface StepUpWebAuthnPanelProps {
  /** One line explaining what tapping the key does. */
  intro: string;
  startLabel: string;
  /** Replaces the button label while the browser prompt is up. */
  verifyingLabel: string;
  running: boolean;
  onStart: () => void;
}

/**
 * The passkey side of the step-up dialog: a sentence and one button. The
 * ceremony itself lives in `runStepUpWebAuthn`; this component only reports
 * that the user asked for it.
 */
export function StepUpWebAuthnPanel({
  intro,
  startLabel,
  verifyingLabel,
  running,
  onStart,
}: StepUpWebAuthnPanelProps) {
  return (
    <>
      <p style={{ margin: 0, fontSize: '0.875rem' }}>{intro}</p>
      <Button
        type="button"
        onClick={onStart}
        disabled={running}
        aria-busy={running}
        data-testid="step-up-webauthn-start"
      >
        {running ? verifyingLabel : startLabel}
      </Button>
    </>
  );
}
